import React from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export default function DashUsage() {
  const [logs, setLogs] = React.useState(null);
  const { t } = useLang();
  React.useEffect(() => {
    api.get("/api/dashboard/usage", { params: { limit: 100 } }).then((r) => setLogs(r.data.items));
  }, []);
  if (!logs) return <div className="h-40 lp-shimmer rounded-2xl" />;
  return (
    <div className="space-y-6" data-testid="dash-usage-page">
      <div>
        <h1 className="font-display text-3xl text-white/95">{t("dash.usage.title")}</h1>
        <p className="text-white/50 text-sm mt-1">{t("dash.usage.subtitle")}</p>
      </div>
      <div className="lp-card overflow-hidden">
        <table className="lp-table">
          <thead>
            <tr>
              <th>{t("dash.usage.col.time")}</th><th>{t("dash.usage.col.endpoint")}</th><th>{t("dash.usage.col.status")}</th><th>{t("dash.usage.col.latency")}</th><th>{t("dash.usage.col.credits")}</th>
            </tr>
          </thead>
          <tbody>
            {logs.length === 0 && (
              <tr><td colSpan={5} className="text-center text-white/50 py-10">{t("dash.usage.empty")}</td></tr>
            )}
            {logs.map((l) => (
              <tr key={l.id} data-testid={`log-row-${l.id}`}>
                <td className="text-white/60 text-xs whitespace-nowrap">{new Date(l.timestamp).toLocaleString()}</td>
                <td className="font-mono text-xs text-white/85">
                  <span className="lp-chip gold mr-2 text-[10px]">{l.method}</span>
                  {l.endpoint}
                </td>
                <td>
                  {l.status_code < 400 ? (
                    <span className="lp-chip green">{l.status_code}</span>
                  ) : (
                    <span className="lp-chip red">{l.status_code}</span>
                  )}
                </td>
                <td className="text-white/70 font-mono text-xs">{l.latency_ms} ms</td>
                <td className="text-white/70 font-mono text-xs">-{l.credits_consumed}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
